<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <v-checkbox
      v-for="checkbox in checkboxOptions"
      :key="checkbox.label"
      :label="checkbox.label"
      color="accent"
      :ripple="false"
      :disabled="disabled"
      :input-value="
        value !== null ? value :
        valueCheckboxInObject(checkbox.code ? checkbox.uuid : checkbox.var_name)
      "
      @change="
        emitsCheckboxValue(
          checkbox.var_name ? checkbox.var_name : checkbox.uuid,
          $event
        )
      "
    />
  </div>
</template>

<script>
import _ from "lodash";
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeCheckBoxNPV",

  mixins: [inputTypeMixin],

  props: {
    checkboxOptions: {
      type: Array
    },
    objectData: {
      type: Object
    },
    value: {
      default: null,
    }
  },

  methods: {
    getValueInObject(varName) {
      return _.get(this.objectData, varName);
    },

    valueCheckboxInObject(varName) {
      let value = this.getValueInObject(varName);

      if (value === "1") {
        return true;
      } else if (value === "0") {
        return false;
      } else {
        return value;
      }
    },
    /**
     * @param {String} varName - Field Name
     * @param {String} newValue - Value
     * sends an object with field and value.
     * The type is used in custom fields component to access the object and send to setValueObject in dynamicObjectFormsMixin.
     */
    emitsCheckboxValue(varName, newValue) {
      this.$emit("change", {
        varName: varName,
        newValue: newValue,
        type: "checkbox"
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/InputTypesNPV/InputTypeCheckBoxNPV.vue